'use strict';

var HeaderPanelDirective = function HeaderPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/header-panel.html'),
    requires: '^rmNewCalendar',
    scope: false
  };
};
HeaderPanelDirective.$inject = [];
module.exports = HeaderPanelDirective;